// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emergency-text-field .form-group .form-control{height:3.5rem}@media(min-width:992px){.emergency-text-field .form-group .form-control{height:4rem;font-size:1.5rem}}", ""]);
// Exports
module.exports = exports;
